import React from "react";

export default function DropDownIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#222" fillRule="nonzero">
          <g>
            <g>
              <g>
                <path
                  d="M7.425 3.8L3.212-.84c-.288-.317-.282-.824.013-1.133.295-.308.767-.302 1.054.015L9 3.242v1.117l-4.72 5.2c-.288.316-.76.322-1.055.014-.295-.309-.3-.816-.013-1.132L7.425 3.8z"
                  transform="translate(-911 -1005) translate(669 985) translate(242 20) translate(4 6) matrix(0 1 1 0 2.2 -2.2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
